import { render } from "./ResourceOverlay.vue?vue&type=template&id=33c5142c&scoped=true"
import script from "./ResourceOverlay.vue?vue&type=script&lang=js"
export * from "./ResourceOverlay.vue?vue&type=script&lang=js"

import "./ResourceOverlay.vue?vue&type=style&index=0&id=33c5142c&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c5142c"]])

export default __exports__